<template>
  <UiPopoverRoot
    v-model:open="isPopoverOpen"
    :id="id"
    :modal="modal"
    @update:open="(open) => !open && emit('close', open)"
  >
    <PopoverAnchor as-child>
      <slot name="anchor" />
    </PopoverAnchor>

    <UiPopoverTrigger :class="classes?.trigger" as-child>
      <slot name="trigger" />
    </UiPopoverTrigger>

    <UiPopoverContent
      v-bind="contentAttrs"
      @close-auto-focus="emit('close-auto-focus', $event)"
      @open-auto-focus="emit('open-auto-focus', $event)"
      :class="classes?.body"
      @click="closePopupOnElementClick"
    >
      <slot />
    </UiPopoverContent>
  </UiPopoverRoot>
</template>

<script setup lang="ts">
import { PopoverAnchor, type PopoverContentProps } from "reka-ui"

import { UiPopoverContentProps } from "@finq/ui/components/ui/Popover/PopoverContent.vue"

const isPopoverOpen = defineModel({ default: false })
const emit = defineEmits<{
  (e: "close", value?: boolean): void
  (e: "close-auto-focus", event: Event): void
  (e: "open-auto-focus", event: Event): void
}>()
export type UiPopoverProps = PopoverContentProps & {
  id?: string
  modal?: boolean
  element?: Nullable<HTMLElement>
  classes?: Partial<{ body: ClassValue; trigger: ClassValue }>
  contentProps?: Partial<UiPopoverContentProps>
}

const props = withDefaults(defineProps<UiPopoverProps>(), {
  align: "start",
  prioritizePosition: true,
})

const closePopupOnElementClick = (e: Event) => {
  const tagName = (e.target as HTMLElement).tagName

  if (["A", "BUTTON"].includes(tagName)) {
    isPopoverOpen.value = false
  }
}

const contentAttrs = computed(() => {
  if (props.element) {
    return { ...props, ...props.contentProps, style: { width: `${props.element.offsetWidth}px` } }
  }

  return { ...props, ...props.contentProps }
})
</script>
